// The basic land names, lowercased. Pure on purpose: no imports and no
// browser globals, so the paste box (prerendered) can use it. utils/tcgplayer
// re-exports isBasicLand for its existing callers.
const BASIC_LANDS = new Set([
  'plains', 'island', 'swamp', 'mountain', 'forest', 'wastes',
  'snow-covered plains', 'snow-covered island', 'snow-covered swamp',
  'snow-covered mountain', 'snow-covered forest', 'snow-covered wastes',
])

export function isBasicLand(name: string): boolean {
  return BASIC_LANDS.has(name.toLowerCase().trim())
}
